import { makeStyles } from '@material-ui/core';

import { COLORS } from 'src/data/ui';

export const useStyles = makeStyles(
  () => ({
    root: {},
    iconStart: {
      color: COLORS.neutral.white,
    },
  }),
  { name: 'HomeItem' }
);
